module.exports = __webpack_public_path__ + "static/img/jiqi-txt.804280f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-txt.png
// module id = RTlB
// module chunks = 0